import { render, staticRenderFns } from "./ListPage.vue?vue&type=template&id=3bcd89a1&"
import script from "./ListPage.vue?vue&type=script&lang=js&"
export * from "./ListPage.vue?vue&type=script&lang=js&"
import style0 from "./ListPage.vue?vue&type=style&index=0&id=3bcd89a1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports